import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type { CurrentMember, MemberListItem } from './types/member';

const request = createAppRequest();
const AUTH_PREFIX = process.env.UMI_APP_AUTH_BFF_URL || '';

export type MemberListQuery = {
  pageNo?: number;
  pageSize?: number;
  keyword?: string;
  departmentId?: string;
  status?: string;
};

type MemberListPageResult = {
  list?: CurrentMember[];
  total?: number;
  totalElements?: number;
  pageNo?: number;
  pageNumber?: number;
  pageSize?: number;
};

export async function getMembers(query?: MemberListQuery, options?: ApiRequestOptions) {
  return request<MemberListPageResult>(`${AUTH_PREFIX}/bff/iam-ui/members`, {
    method: 'GET',
    params: query,
    ...(options || {}),
  });
}

export async function queryMembers(query?: MemberListQuery): Promise<MemberListItem[]> {
  const result = await request<MemberListPageResult>(`${AUTH_PREFIX}/bff/iam-ui/members`, {
    method: 'GET',
    params: query,
  });
  return result?.list ?? [];
}

